const schema = localStorage.getItem("schema")
export const basicFormData = () => ({
  inputData: {
    country_id: "",
    state_id: "",
    city_id: "",
    branch_name: "",
    created_by: "",
    updated_by: "",
    is_active: true,
  },
});

export const createPageData = () => {
  const payload = {
    modelName: "branch_masters",
    schema:schema,
    "include": [
      {
        "model": "country_masters",
        "as": "country"
      },
      {
        "model": "state_masters",
        "as": "state"
      },
      {
        "model": "city_masters",
        "as": "city"
      }
    ]
  };

  const navigatePage = { back: "/branch-list" };

  const headerName = "Branch";

  const validationType = "BranchCreate";
  const createEndpoint = "/updaterelationaldata  ";
  const updateEndpoint = "/updaterelationaldata  ";
  const getEndpoint = "/getRecords";
  const dependentDropdownData = [
    {
      module_name: "branch_masters",
      initialPayload: {
        modelName: "branch_masters",
        schema:schema,
        whereCondition: { is_child: false },
      },
      isOtherDependentOnThis: false,
      patchFieldName: "branch_name",
      dropdownDataValue: "parent_id",
      endPoint: "/getRecords",
    },
  ];
  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
    dependentDropdownData,
  };
};

export const listPageData = () => {
  const payload = {
    modelName: "branch_masters",
    schema:schema,
    "include": [
      {
        "model": "country_masters",
        "as": "country"
      },
      {
        "model": "state_masters",
        "as": "state"
      }      ,
      {
        "model": "city_masters",
        "as": "city"
      }
    ]
    // relations: [
    //   {
    //     module: "user_masters",
    //     moduleAs: "createdBy",
    //   },
    //   {
    //     module: "user_masters",
    //     moduleAs: "updatedBy",
    //   },
    //   {
    //     module: "user_masters",
    //     moduleAs: "updatedBy",
    //   },
    // ],
  };

  const columnData = [
    { label: "Sr.no", value: "index" },
    { label: "Country Name", value: "country.country_name" },
    { label: "State Name", value: "state.state_name" },
    { label: "City Name", value: "city.city_name" },
    { label: "Branch Name", value: "branch_name" },
    { label: "Status", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/branch-create",
    edit: "/branch-create",
    view: "/branch-view",
  };

  const searchfields = [
    "branch_name",
    "country_name",
    "state_name",
    "city_name",
  ];

  const headerName = "Branch";
  const endpoint = "/getRecords";
  const exportFileName = "BranchData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
  };
};

export const exportPageData = {
  modelName: "branch_masters",
  schema:schema,
  include:[
    { module: "country_masters", moduleAs: "country" },
    { module: "state_masters", moduleAs: "state" },
    { module: "city_masters", moduleAs: "city" }
  ],
  pagination: { page: 1, pageSize: 10000 },
};
